export default function Briefcase() {
  return (
    <svg
      className="fill-none"
      viewBox="1 1 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          className="stroke-current stroke-2 stroke-join-round"
          d="M3 11C3 9.11438 3 8.17157 3.58579 7.58579C4.17157 7 5.11438 7 7 7H8H16H17C18.8856 7 19.8284 7 20.4142 7.58579C21 8.17157 21 9.11438 21 11V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H16H8H7C5.11438 21 4.17157 21 3.58579 20.4142C3 19.8284 3 18.8856 3 17V11Z"
        />
        <path
          className="stroke-current stroke-2 stroke-join-round"
          d="M8 21V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V21"
        />
      </g>
    </svg>
  );
};